import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { PersistGate } from 'redux-persist/integration/react';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from './apollo';
import locale from './locale';
import { store, persistor } from './store';
import App from './components/App';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import AppConfig from '@config';
import HackleCustomProvider from '@components/Provider/HackleProvider';
import { worker } from './mocks/browser';

if (AppConfig.mode === 'development' && AppConfig.Mocking === 'TRUE') {
  worker.start({
    onUnhandledRequest: 'bypass'
  });
}

Sentry.init({
  dsn:
    'https://3a19ebbbf60e4fb08cb9f9d654593432@o1141124.ingest.sentry.io/6203433',
  environment: AppConfig.mode,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0,
  normalizeDepth: 10,
  beforeBreadcrumb: (breadCrumb, hint) => {
    const loggingHintCategories = ['exception', 'fetch', 'xhr'];
    if (loggingHintCategories.includes(breadCrumb.category as string) && hint) {
      breadCrumb.data = {
        ...(breadCrumb.data ?? {}),
        ...hint
      };
    }
    return breadCrumb;
  },
  enabled:
    AppConfig.mode === 'production' && window.location.hostname !== 'localhost'
});

const { IMP } = window;

IMP?.init(AppConfig.IMPStoreCode ?? '');

ReactDOM.render(
  <ApolloProvider client={apolloClient}>
    <Provider store={store}>
      <HackleCustomProvider>
        <PersistGate loading={null} persistor={persistor}>
          <IntlProvider locale="ko" messages={locale.ko}>
            <App />
          </IntlProvider>
        </PersistGate>
      </HackleCustomProvider>
    </Provider>
  </ApolloProvider>,
  document.getElementById('root')
);

// cypress 테스트를 위한 redux store 노출
if ((window as Window & { Cypress?: any }).Cypress) {
  (window as Window & { store?: any }).store = store;
}
